// export const carregandoDadosEmpresa = ({ companyDataLoaded }) => (companyDataLoaded !== true)
export const getCompanyDataLoaded = ({ companyDataLoaded }) => companyDataLoaded
export const hasDominioValido = ({ companyData }) => companyData
export const hasToken = ({ token }) => !!token
export const getUserData = ({ userData }) => userData